import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BuildingIcon, CheckIcon, CreditCardIcon, LockIcon, WalletIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { formatPrice } from '../utils/format';
import { COLORS } from '../data/products';
import { useScreenInit } from '../useScreenInit.js';
const STEPS = [{
  id: 1,
  label: 'Información de contacto'
}, {
  id: 2,
  label: 'Dirección de envío'
}, {
  id: 3,
  label: 'Método de pago'
}];
const PAYMENTS = [{
  id: 'card',
  label: 'Tarjeta de crédito/débito',
  hint: 'Visa, Mastercard, OCA, Cabal',
  icon: CreditCardIcon
}, {
  id: 'mp',
  label: 'MercadoPago',
  hint: 'Pagá con tu saldo o cuotas sin interés',
  icon: WalletIcon
}, {
  id: 'transfer',
  label: 'Transferencia bancaria',
  hint: 'BROU, Itaú, Santander — 5 % off',
  icon: BuildingIcon
}];
const DEPARTMENTS = ['Montevideo', 'Canelones', 'Maldonado', 'Colonia', 'Salto', 'Paysandú', 'Rivera', 'Tacuarembó'];
const fieldClass = 'w-full border border-white/10 bg-ink-800 px-4 py-3.5 text-sm text-white placeholder:text-white/30 focus:border-pink-500 focus:outline-none';
const labelClass = 'block text-[10px] font-bold uppercase tracking-[0.2em] text-white/45';
export function Checkout() {
  const {
    lines,
    lineProduct,
    subtotal,
    shipping,
    discount,
    total,
    couponCode
  } = useCart();
  const screenInit = useScreenInit();
  const [payment, setPayment] = useState('card');
  const [confirmed, setConfirmed] = useState(Boolean(screenInit.confirmed));
  if (confirmed) {
    return <div className="mx-auto max-w-2xl px-5 py-28 text-center" data-id="element-895" data-mp="3qbjm3b4ru8rl">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-teal-500" data-id="element-896" data-mp="3udo9vt8jgb6b">
          <CheckIcon className="h-8 w-8 text-black" data-id="element-897" data-mp="15mn5faoyo45f" />
        </div>
        <h1 className="mt-8 font-display text-5xl uppercase leading-none text-white" data-id="element-898" data-mp="15oge0vj4wyg2">
          Pedido confirmado
        </h1>
        <p className="mt-4 text-sm leading-relaxed text-white/50" data-id="element-899" data-mp="36o39f8tr391d">
          Te enviamos el detalle del pedido <strong className="text-white" data-id="element-900" data-mp="31prvalwfacdc">#ZD-1043</strong> por
          correo. Preparamos el envío en las próximas 24 horas.
        </p>
        <Link to="/productos" className="mt-9 inline-block bg-pink-500 px-8 py-4 text-[11px] font-bold uppercase tracking-[0.18em] text-white transition-colors hover:bg-pink-600" data-id="element-901" data-mp="3foht63r2gg2r">
          Seguir comprando
        </Link>
      </div>;
  }
  return <div className="w-full bg-black" data-id="element-902" data-mp="2izscggr6dtid">
      <div className="mx-auto w-full max-w-7xl px-5 py-12 lg:px-8 lg:py-16" data-id="element-903" data-mp="2iwo0gx7gxth5">
        <h1 className="font-display text-5xl uppercase leading-none text-white sm:text-6xl" data-id="element-904" data-mp="2wrqek7mgyp51">
          Checkout
        </h1>

        {/* STEP INDICATOR */}
        <ol className="mt-9 flex flex-col gap-4 border-y border-white/10 py-6 sm:flex-row sm:items-center sm:gap-8" data-id="element-905" data-mp="249cowvbae9h1">
          {STEPS.map(step => <li key={step.id} className="flex items-center gap-3" data-id="element-906" data-mp="1zahxj4z97clb">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-pink-500 font-display text-sm text-white" data-id="element-907" data-mp="ero6kohtoejb">
                {step.id}
              </span>
              <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-white" data-id="element-908" data-mp="5su1sauc8huo">
                {step.label}
              </span>
              {step.id !== 3 && <span className="hidden h-[1px] w-10 bg-white/15 sm:block" data-id="element-909" data-mp="ygzoh34ycgx5" />}
            </li>)}
        </ol>

        <form onSubmit={e => {
        e.preventDefault();
        setConfirmed(true);
      }} className="mt-10 grid gap-10 lg:grid-cols-[1fr_380px]" data-id="element-910" data-mp="12ha5rby72trb">
          <div className="space-y-12" data-id="element-911" data-mp="tgkbwdshvdg8">
            {/* STEP 1 */}
            <section aria-labelledby="step-1" data-id="element-912" data-mp="398rht0f6kk0x">
              <h2 id="step-1" className="font-display text-3xl uppercase leading-none text-white" data-id="element-913" data-mp="397zqw2wj3agz">
                <span className="text-pink-500" data-id="element-914" data-mp="3thhhy49gd2tb">01</span> Información de contacto
              </h2>
              <div className="mt-6 grid gap-5 sm:grid-cols-2" data-id="element-915" data-mp="3oqsr8r5lk9v8">
                <div data-id="element-916" data-mp="3ophmop4buy32">
                  <label className={labelClass} htmlFor="nombre" data-id="element-917" data-mp="3ooy210nalvlc">
                    Nombre completo
                  </label>
                  <input id="nombre" required autoComplete="name" placeholder="Camila Rodríguez" className={`mt-2 ${fieldClass}`} data-id="element-918" data-mp="3fqmfb9pjrhy6" />
                </div>
                <div data-id="element-919" data-mp="c7jh7ouhte5p">
                  <label className={labelClass} htmlFor="email" data-id="element-920" data-mp="79ro4ri43lzx">
                    Email
                  </label>
                  <input id="email" type="email" required autoComplete="email" placeholder="camila@mail.com" className={`mt-2 ${fieldClass}`} data-id="element-921" data-mp="2bzo1a7bctkn" />
                </div>
                <div className="sm:col-span-2" data-id="element-922" data-mp="2cyjo2lwllrwy">
                  <label className={labelClass} htmlFor="tel" data-id="element-923" data-mp="2cvno6s16wt5v">
                    Teléfono
                  </label>
                  <input id="tel" type="tel" required autoComplete="tel" placeholder="+598 99 123 456" className={`mt-2 ${fieldClass}`} data-id="element-924" data-mp="2mvy3ci6scano" />
                </div>
              </div>
            </section>

            {/* STEP 2 */}
            <section aria-labelledby="step-2" data-id="element-925" data-mp="30l8bto8agelh">
              <h2 id="step-2" className="font-display text-3xl uppercase leading-none text-white" data-id="element-926" data-mp="35lmlfapjfwlm">
                <span className="text-pink-500" data-id="element-927" data-mp="3akhague3mhe6">02</span> Dirección de envío
              </h2>
              <div className="mt-6 grid gap-5 sm:grid-cols-2" data-id="element-928" data-mp="1b9pqh7rw08lt">
                <div className="sm:col-span-2" data-id="element-929" data-mp="1g6g3fm8eao30">
                  <label className={labelClass} htmlFor="calle" data-id="element-930" data-mp="1g9c1rbo5nerz">
                    Dirección
                  </label>
                  <input id="calle" required autoComplete="street-address" placeholder="Bvar. Artigas 1234, apto 502" className={`mt-2 ${fieldClass}`} data-id="element-931" data-mp="137gpn6i033nm" />
                </div>
                <div data-id="element-932" data-mp="1d7zc890y8y98">
                  <label className={labelClass} htmlFor="depto" data-id="element-933" data-mp="1r4w32ah2ifq4">
                    Departamento
                  </label>
                  <select id="depto" required defaultValue="Montevideo" className={`mt-2 ${fieldClass}`} data-id="element-934" data-mp="1m59nvvhoipeo">
                    {DEPARTMENTS.map(d => <option key={d} value={d} data-id="element-935" data-mp="29vvncydmb1d2">
                        {d}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-936" data-mp="25s7f0dh5w1qr">
                  <label className={labelClass} htmlFor="ciudad" data-id="element-937" data-mp="2oikvtppukovl">
                    Ciudad / Barrio
                  </label>
                  <input id="ciudad" required placeholder="Pocitos" className={`mt-2 ${fieldClass}`} data-id="element-938" data-mp="2thxk8ewda40a" />
                </div>
                <div data-id="element-939" data-mp="2kfo6zh9prwj7">
                  <label className={labelClass} htmlFor="cp" data-id="element-940" data-mp="2kj3pyv6idppw">
                    Código postal
                  </label>
                  <input id="cp" required autoComplete="postal-code" placeholder="11300" className={`mt-2 ${fieldClass}`} data-id="element-941" data-mp="2aitd5bodykb9" />
                </div>
                <div data-id="element-942" data-mp="20tjmm096x9p9">
                  <label className={labelClass} htmlFor="notas" data-id="element-943" data-mp="20qnkdzqb7yv0">
                    Referencia (opcional)
                  </label>
                  <input id="notas" placeholder="Dejar en portería" className={`mt-2 ${fieldClass}`} data-id="element-944" data-mp="1rsv3ws8uql61" />
                </div>
              </div>
            </section>

            {/* STEP 3 */}
            <section aria-labelledby="step-3" data-id="element-945" data-mp="229fj36bahmsq">
              <h2 id="step-3" className="font-display text-3xl uppercase leading-none text-white" data-id="element-946" data-mp="1y8lvke1rea0d">
                <span className="text-pink-500" data-id="element-947" data-mp="1tcwolpnetqu1">03</span> Método de pago
              </h2>
              <div className="mt-6 space-y-3" data-id="element-948" data-mp="1odk5nfznt3wq">
                {PAYMENTS.map(({
                id,
                label,
                hint,
                icon: Icon
              }) => <label key={id} className={`flex cursor-pointer items-center gap-4 border p-4 transition-colors ${payment === id ? 'border-pink-500 bg-pink-500/5' : 'border-white/10 bg-ink-800 hover:border-white/30'}`} data-id="element-949" data-mp="1elnub38kbhak">
                    <input type="radio" name="payment" checked={payment === id} onChange={() => setPayment(id)} className="h-4 w-4 shrink-0 appearance-none rounded-full border border-white/25 checked:border-[5px] checked:border-pink-500 focus:outline-none" data-id="element-950" data-mp="10nzkcqg19uka" />
                    <Icon className={`h-5 w-5 shrink-0 ${payment === id ? 'text-pink-500' : 'text-white/40'}`} data-id="element-951" data-mp="3q8855r539422" />
                    <span className="min-w-0" data-id="element-952" data-mp="2yi3amznm70n4">
                      <span className="block text-sm font-semibold text-white" data-id="element-953" data-mp="32ix1a0sfytjp">
                        {label}
                      </span>
                      <span className="block text-xs text-white/40" data-id="element-954" data-mp="37bq2wfsm5lrk">{hint}</span>
                    </span>
                  </label>)}
              </div>

              {payment === 'card' && <div className="mt-6 grid gap-5 border border-white/10 bg-ink-800 p-5 sm:grid-cols-2" data-id="element-955" data-mp="2es1fbkao2skd">
                  <div className="sm:col-span-2" data-id="element-956" data-mp="269rizg0bvp36">
                    <label className={labelClass} htmlFor="card-num" data-id="element-957" data-mp="2b5yox8sq50l4">
                      Número de tarjeta
                    </label>
                    <input id="card-num" inputMode="numeric" placeholder="4242 4242 4242 4242" className={`mt-2 ${fieldClass} bg-ink-900`} data-id="element-958" data-mp="2f94sg8ogcdnw" />
                  </div>
                  <div className="sm:col-span-2" data-id="element-959" data-mp="1rjsmdhof8lpt">
                    <label className={labelClass} htmlFor="card-name" data-id="element-960" data-mp="1rgemqh756qm2">
                      Titular de la tarjeta
                    </label>
                    <input id="card-name" placeholder="CAMILA RODRIGUEZ" className={`mt-2 ${fieldClass} bg-ink-900 uppercase`} data-id="element-961" data-mp="219lxkhkniytj" />
                  </div>
                  <div data-id="element-962" data-mp="18q6ks2f6i67g">
                    <label className={labelClass} htmlFor="card-exp" data-id="element-963" data-mp="118qh9m9gonpc">
                      Vencimiento
                    </label>
                    <input id="card-exp" placeholder="MM / AA" className={`mt-2 ${fieldClass} bg-ink-900`} data-id="element-964" data-mp="wap1pbb8v6im" />
                  </div>
                  <div data-id="element-965" data-mp="n87h11b8mlxq">
                    <label className={labelClass} htmlFor="card-cvv" data-id="element-966" data-mp="nb1xkhr4rmlv">
                      CVV
                    </label>
                    <input id="card-cvv" inputMode="numeric" placeholder="123" className={`mt-2 ${fieldClass} bg-ink-900`} data-id="element-967" data-mp="djfreztngdpz" />
                  </div>
                </div>}
            </section>
          </div>

          {/* SUMMARY */}
          <aside className="lg:sticky lg:top-28 lg:self-start" data-id="element-968" data-mp="3vo9b7a9in6r1">
            <div className="border border-white/10 bg-ink-800 p-6" data-id="element-969" data-mp="3qpft14jaarkj">
              <h2 className="font-display text-2xl uppercase tracking-wide text-white" data-id="element-970" data-mp="3h23h5pnq9phs">
                Tu pedido
              </h2>

              <ul className="mt-6 space-y-4" data-id="element-971" data-mp="3l3xebnypsbd7">
                {lines.map(line => {
                const product = lineProduct(line);
                if (!product) return null;
                const color = COLORS.find(c => c.id === line.colorId);
                const unit = product.salePrice ?? product.price;
                return <li key={line.id} className="flex items-center gap-3" data-id="element-972" data-mp="3pjlqqtbvogw">
                      <div className="relative h-14 w-14 shrink-0 overflow-hidden bg-black" data-id="element-973" data-mp="8lqraihtaxyb">
                        <img src={product.images[0]} alt={product.name} className="h-full w-full object-cover" data-id="element-974" data-mp="3q28pq34nqtxj" />
                        <span className="absolute right-0 top-0 bg-pink-500 px-1 text-[10px] font-bold text-white" data-id="element-975" data-mp="mkqfjp1exaty">
                          {line.quantity}
                        </span>
                      </div>
                      <div className="min-w-0 flex-1" data-id="element-976" data-mp="2c0u6ug7ru4yk">
                        <p className="truncate text-sm font-semibold text-white" data-id="element-977" data-mp="273arte391o5k">
                          {product.name}
                        </p>
                        <p className="text-xs text-white/40" data-id="element-978" data-mp="2gtvnasnmmck9">{color?.name}</p>
                      </div>
                      <span className="text-sm text-white" data-id="element-979" data-mp="1t41d6iuoz23p">
                        {formatPrice(unit * line.quantity)}
                      </span>
                    </li>;
              })}
              </ul>

              <dl className="mt-6 space-y-3 border-t border-white/10 pt-6 text-sm" data-id="element-980" data-mp="22628vbaa1g39">
                <div className="flex justify-between" data-id="element-981" data-mp="1x5ej0sxsb5am">
                  <dt className="text-white/50" data-id="element-982" data-mp="1x80q6rgrjisb">Subtotal</dt>
                  <dd className="text-white" data-id="element-983" data-mp="3dj4qm9o44bp0">{formatPrice(subtotal)}</dd>
                </div>
                <div className="flex items-center justify-between" data-id="element-984" data-mp="38k1iuhgqzrdc">
                  <dt className="text-white/50" data-id="element-985" data-mp="7q3s5swi9km1">Envío</dt>
                  <dd data-id="element-986" data-mp="7rez21l8z8hd">
                    {shipping === 0 ? <span className="bg-teal-500 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-black" data-id="element-987" data-mp="co5csi9kxrzm">
                        Gratis
                      </span> : <span className="text-white" data-id="element-988" data-mp="mo5uy0vpq228">{formatPrice(shipping)}</span>}
                  </dd>
                </div>
                {discount > 0 && <div className="flex justify-between" data-id="element-989" data-mp="vn13vkq55q98">
                    <dt className="text-white/50" data-id="element-990" data-mp="vlq37trzsymc">Descuento {couponCode}</dt>
                    <dd className="text-pink-400" data-id="element-991" data-mp="10f1a1uwt1fe9">- {formatPrice(discount)}</dd>
                  </div>}
              </dl>

              <div className="mt-6 flex items-end justify-between border-t border-white/10 pt-6" data-id="element-992" data-mp="1acp8ovxj771p">
                <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/50" data-id="element-993" data-mp="1eeag41raqt4i">
                  Total
                </span>
                <span className="font-display text-4xl leading-none text-white" data-id="element-994" data-mp="2yx4gt9yj55jp">
                  {formatPrice(total)}
                </span>
              </div>

              <button type="submit" className="mt-6 w-full bg-pink-500 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-pink-600" data-id="element-995" data-mp="2pven1xh6duir">
                Confirmar pedido
              </button>
              <p className="mt-4 flex items-center justify-center gap-2 text-[11px] text-white/35" data-id="element-996" data-mp="3im53ssluj58f">
                <LockIcon className="h-3.5 w-3.5" data-id="element-997" data-mp="3dnlganrltldy" /> Pago protegido con
                encriptación SSL
              </p>
              <Link to="/carrito" className="mt-4 block text-center text-[11px] uppercase tracking-[0.16em] text-white/50 hover:text-white" data-id="element-998" data-mp="33vpf33u81f5i">
                Volver al carrito
              </Link>
            </div>
          </aside>
        </form>
      </div>
    </div>;
}